module.exports = __webpack_public_path__ + "img/notaire.586240ec.webp";